import React from 'react';
import { Chip } from '../../Chip/index.js';
import { getFilterChips, getFilterUniqueKey, formatDateFilterChip } from '../functions/index.js';
import { DateFilter } from '../DateFilter.js';

var FilterChips = function FilterChips(_ref) {
  var disabled = _ref.disabled,
      filters = _ref.filters,
      onRemoveFilter = _ref.onRemoveFilter,
      style = _ref.style;
  var chips = getFilterChips(filters);

  var getFilterDisplayValue = function getFilterDisplayValue(filter) {
    if (filter.type === DateFilter) {
      return formatDateFilterChip(filter);
    }

    var labelKey = filter.labelKey || 'label';
    return filter.getChipDisplay ? filter.getChipDisplay(filter.value) : filter.value[labelKey];
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "legacy-chips",
    style: style,
    "data-component-type": "filter-chips-row"
  }, chips.map(function (filter) {
    return /*#__PURE__*/React.createElement(Chip, {
      key: getFilterUniqueKey(filter),
      category: filter.label,
      data: filter.data,
      value: getFilterDisplayValue(filter),
      onRemove: function onRemove() {
        return onRemoveFilter === null || onRemoveFilter === void 0 ? void 0 : onRemoveFilter(filter);
      },
      disabled: disabled || filter.disabled
    });
  }));
};

FilterChips.displayName = "FilterChips";
FilterChips.displayName = 'FilterChips';
export { FilterChips };